import { Box, Checkbox, FormControlLabel, Grid, Paper, Typography } from "@mui/material";
import { lineOfBusinessModel } from "../Lists/CarrierManagementList";

interface Iprops {
    selectedLineOfbusiness: lineOfBusinessModel[],
    lineOfBusiness: lineOfBusinessModel[],
    handleCheckBoxChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const LineOfBusinessCheckBox: React.FC<Iprops> = ({ selectedLineOfbusiness, lineOfBusiness, handleCheckBoxChange }) => {
    const selected = selectedLineOfbusiness ?? [];
    const options = lineOfBusiness ?? [];
    const isChecked = (id: number) => selected.some((element) => element.id === id);
    const selectedCount = selected.length;
    const totalCount = options.length;

    const handleRowClick = (item: lineOfBusinessModel) => () => {
        const syntheticEvent = {
            target: { name: item.id.toString(), checked: !isChecked(item.id) },
        } as React.ChangeEvent<HTMLInputElement>;
        handleCheckBoxChange(syntheticEvent);
    };

    return (
        <Paper
            variant="outlined"
            sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: 'grey.50',
                borderColor: 'divider',
            }}
        >
            {totalCount > 0 && (
                <Typography
                    variant="caption"
                    sx={{
                        display: 'block',
                        mb: 1.5,
                        color: 'text.secondary',
                        fontWeight: 500,
                    }}
                >
                    {selectedCount} of {totalCount} selected
                </Typography>
            )}
            <Grid container spacing={1.5}>
                {options.map((item) => {
                    const checked = isChecked(item.id);
                    return (
                        <Grid item key={item.id} xs={12} sm={6}>
                            <Box
                                role="button"
                                tabIndex={0}
                                onClick={handleRowClick(item)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        handleRowClick(item)();
                                    }
                                }}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    px: 2,
                                    py: 1.5,
                                    minHeight: 44,
                                    borderRadius: 1.5,
                                    cursor: 'pointer',
                                    transition: 'background-color 0.15s ease, box-shadow 0.15s ease',
                                    border: '1px solid',
                                    borderColor: checked ? 'primary.main' : 'transparent',
                                    bgcolor: checked ? '#2099d214' : 'transparent',
                                    '&:hover': {
                                        bgcolor: checked ? '#2099d214' : 'action.hover',
                                    },
                                    '&:focus-visible': {
                                        outline: '2px solid',
                                        outlineColor: 'primary.main',
                                        outlineOffset: 2,
                                    },
                                }}
                            >
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name={item.id.toString()}
                                            onChange={handleCheckBoxChange}
                                            checked={checked}
                                            size="small"
                                            onClick={(e) => e.stopPropagation()}
                                            sx={{
                                                color: '#2099d2',
                                                '&.Mui-checked': {
                                                    color: '#2099d2',
                                                },
                                                p: 0.5,
                                            }}
                                        />
                                    }
                                    label={
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontWeight: 500,
                                                color: 'text.primary',
                                                userSelect: 'none',
                                                paddingTop: '4px',
                                            }}
                                        >
                                            {item.businessCode}
                                        </Typography>
                                    }
                                    sx={{
                                        m: 0,
                                        flex: 1,
                                        justifyContent: 'flex-start',
                                        alignItems: 'flex-start',
                                        pointerEvents: 'none',
                                        '& .MuiFormControlLabel-label': {
                                            flex: 1,
                                        },
                                    }}
                                />
                            </Box>
                        </Grid>
                    );
                })}
            </Grid>
        </Paper>
    );
}